import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpEnumObject } from './op-enum-object'


export class OpHistory  {
    //Properties
    public eventDate: Date
    public objectHistoryEventType: Enums.ObjectHistoryEventType
    public eventType: OpEnumObject
    public descr: string
    public longDescr: string
    public eventObject: any
    //Properties end

    constructor(opObj: any) {
        if (opObj) {
            this.eventDate = opObj.EventDate
            this.objectHistoryEventType = opObj.ObjectHistoryEventType
            this.eventType = new OpEnumObject(opObj.EventType)
            this.descr = opObj.Descr
            this.longDescr = opObj.LongDescr
            this.eventObject = opObj.EventObject
        }
    }
}